module.exports = __webpack_public_path__ + "static/media/game-interviewer16.7fbd75ae.png";